
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type EmptySearchPageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function EmptySearchPageRT(): TemplateResult<EmptySearchPageRTRootProps> {
    return _createElement('div', { 'className': 'cm_hide' });
}
        export const componentNames = []